import React, { useState } from 'react';
import { createGlobalAdminAPI } from '../services/serverService';
import { ROLES } from '../config/permissions';

const AddGlobalAdminModal = ({ closeModal, refreshList }) => {
    const [formData, setFormData] = useState({
        username: '',
        fullName: '',
        email: '',
        password: '',
        permissionLevel: ROLES.SUPPORT,
        isSupportManager: false
    });
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await createGlobalAdminAPI(formData);
            alert(`Success! Login using username: ${formData.username}`);
            refreshList();
            closeModal();
        } catch (error) {
            alert("Error: " + (error.response?.data?.message || error.message));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="modal-close-button" onClick={closeModal}>&times;</button>
                <h2>Add Global Super Admin</h2>
                <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '20px' }}>
                    Creates a new user with <strong>Global Access</strong>.
                </p>

                <form onSubmit={handleSubmit}>
                    
                    {/* USERNAME FIELD */}
                    <div className="form-group">
                        <label>Username (Login ID)</label>
                        <input 
                            required 
                            placeholder="e.g. harshit.dev"
                            value={formData.username}
                            onChange={e => setFormData({...formData, username: e.target.value.trim()})}
                        />
                        <small style={{display:'block', color:'#888', marginTop:'5px'}}>Must be unique.</small>
                    </div>

                    <div className="form-group">
                        <label>Full Name</label>
                        <input 
                            required 
                            value={formData.fullName}
                            onChange={e => setFormData({...formData, fullName: e.target.value})}
                        />
                    </div>
                    
                    <div className="form-group">
                        <label>Contact Email</label>
                        <input 
                            type="email" required 
                            value={formData.email}
                            onChange={e => setFormData({...formData, email: e.target.value})}
                        />
                        <small style={{display:'block', color:'#888', marginTop:'5px'}}>Can be shared by multiple accounts.</small>
                    </div>

                    <div className="form-group">
                        <label>Password</label>
                        <input 
                            type="password" required 
                            value={formData.password}
                            onChange={e => setFormData({...formData, password: e.target.value})}
                        />
                    </div>
                    
                    <div className="form-group">
                        <label>Global Role</label>
                        <select 
                            value={formData.permissionLevel}
                            onChange={e => setFormData({...formData, permissionLevel: e.target.value})}
                            style={{ padding: '10px', width: '100%' }}
                        >
                            <option value={ROLES.SUPPORT}>Support (Read/Edit All, No Delete)</option>
                            <option value={ROLES.DEV}>Dev (Full Access + OTPs)</option>
                        </select>
                    </div>

                    <div className="form-group" style={{ marginTop: '15px', padding: '10px', backgroundColor: '#f8fafc', borderRadius: '6px', border: '1px solid #e2e8f0' }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '10px', margin: 0, cursor: 'pointer', fontWeight: 'normal' }}>
                            <input 
                                type="checkbox" 
                                checked={formData.isSupportManager}
                                onChange={e => setFormData({...formData, isSupportManager: e.target.checked})}
                                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                            />
                            <strong>Grant Support Manager Privileges</strong> 
                            <span style={{ fontSize: '12px', color: '#718096' }}>(Access to Routing Rules & Billing Tickets)</span>
                        </label>
                    </div>

                    <div className="modal-actions">
                        <button type="button" className="button-secondary" onClick={closeModal}>Cancel</button>
                        <button type="submit" className="button-primary" disabled={loading}>
                            {loading ? 'Creating...' : 'Create Admin'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddGlobalAdminModal;